import { downloadExportZip } from '@/api/recipes'
import { Button } from '@/components/Button'
import { Spinner } from '@/components/Spinner'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

export default function DownloadButton() {
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()

  const downloadFile = async () => {
    try {
      setLoading(true)
      const response = await downloadExportZip()

      if (response.status !== 200) {
        throw new Error('Network response was not ok')
      }

      const blob = response.data
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'databases.zip'
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)

      setLoading(false)
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error)
    }
  }

  return (
    <div>
      <Button style={{ marginLeft: '10px' }} variant="default" onPress={downloadFile}>
        {t('utils.download')}
      </Button>
      {loading && <Spinner />}
    </div>
  )
}
